import { ServiceRequest } from "@curai/js-fhir-tools";
import { z } from "zod";

export const formatZipCode = (zip: string | undefined) => {
  if (!zip) return undefined;
  // Extract just the first 5 digits if it's a ZIP+4
  const match = zip.match(/^(\d{5})/);
  return match ? match[1] : undefined;
};

export const searchSchema = z
  .object({
    labNetwork: z.nativeEnum(ServiceRequest.LAB_NETWORKS),
    city: z.string().optional(),
    state: z.string().optional(),
    zip: z.string().optional(),
  })
  .refine(
    (data) => {
      if (data.city) {
        return data.city.trim().length >= 2;
      }
      return true;
    },
    {
      message: "City must be at least 3 characters",
      path: ["city"],
    },
  )
  .refine(
    (data) => {
      if (data.state) {
        return data.state.trim().length === 2;
      }
      return true;
    },
    {
      message: "State must be the 2-letter abbreviation",
      path: ["state"],
    },
  )
  .refine(
    (data) => {
      if (data.zip) {
        return /^\d{5}$/.test(data.zip);
      }
      return true;
    },
    {
      message: "ZIP code must be 5 digits",
      path: ["zip"],
    },
  )
  .refine(
    (data) => {
      if (!data.zip && !data.state) {
        return false;
      }
      return true;
    },
    {
      message:
        "A state or zip code is required to search for Patient Service Centers.",
    },
  );
